(function () {
  'use strict';

  angular
    .module('payment')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('payment', {
        url: '/payment',
        views: {
        	'paymentView' : {
        		templateUrl: 'payment/views/payment.tpl.html',
                controller: 'PaymentCtrl',
                controllerAs: 'payment'
        	}
        }
      });
  }
}());
